<template>
    <div style="height:calc(100%); padding: 5px;">
        <el-row style="font-weight: bold; margin-bottom: 10px;" v-if="login_errMsg.length == 0">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                {{ start32_code }} / {{ start32_shop}}
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                {{ customerName }}
            </el-col>
        </el-row>
        <div v-else style="color: red; font-weight: bold; padding: 20px;">{{ login_errMsg }}</div>
        <div v-if="login">
            <div style="clear: both; height: 25px; font-weight: bold; ">{{ lstLabel.length > 23 ? lstLabel[23] : '第一步' }}:</div>
            <div style="display: flex;">
                <div style="flex-grow: 0; flex-shrink: 0; width: 120px;">{{ lstLabel.length > 0 ? lstLabel[0] : '上傳圖片' }}：</div>
                <div style="flex-grow: 1;">
                    <UploadFile ref="Scan_File" :hideUploadBtn="running" :lab_1="lstLabel.length > 1 ? lstLabel[1] : '點擊上傳'" 
                        :lab_2="lstLabel.length > 3 ? lstLabel[3] : 'jpg/png文件'" 
                        :lab_3="lstLabel.length > 4 ? lstLabel[4] : '只能上傳jpg/png文件'" 
                        :lab_4="lstLabel.length > 26 ? lstLabel[26] : '點一下，Ctrl+V'" 
                        :compressBeforeUpload="true" />
                </div>
            </div>
            <div style="display: flex; padding-top: 25px;">
                <div style="flex-grow: 0; flex-shrink: 0; width: 120px;">&nbsp;</div>
                <div style="flex-grow: 1;">
                    <el-button type="primary" size="mini" @click="Recognition" ref="btnStart" :disabled="running">{{ lstLabel.length > 5 ? lstLabel[5] : '開始識別' }}</el-button>
                </div>
            </div>
            <div style="display: flex; justify-content: center; padding-top: 25px; color:brown" v-if="running">
                <i class="el-icon-loading" style="font-size: 20px; vertical-align: middle;"></i>
                <span style="font-size: 16px; font-weight: bold; vertical-align: middle; margin-left: 10px;">
                    {{ (lstLabel.length > 13 ? lstLabel[13] : '正在處理第{n}張').replace('{n}', processIndex) }}
                    ( {{  ItemsOfImage }} )
                </span>
            </div>
            <div style="clear: both; height: 25px; font-weight: bold;">{{ lstLabel.length > 24 ? lstLabel[24] : '第二步' }}:</div>
            <div style="display: flex;">
                <div style="flex-grow: 0; flex-shrink: 0; width: 120px;">{{ lstLabel.length > 2 ? lstLabel[2] : '餐牌名' }}：</div>
                <div style="flex-grow: 1;">
                    <el-input v-model="menu_name" :disabled="running" maxlength="50" size="mini" ref="mname" @focus="selectAll"></el-input>
                </div>
            </div>
            <div style="clear: both; height: 25px; "></div>
            <div style="display: flex;">
                <div style="flex-grow: 0; flex-shrink: 0; width: 120px; font-weight: bold;">{{ lstLabel.length > 25 ? lstLabel[25] : '第三步' }}:</div>
                <div style="flex-grow: 1;">
                    <el-button type="success" size="mini" @click="SaveItem" ref="btnSave" :disabled="running || Items.length == 0">{{ lstLabel.length > 6 ? lstLabel[6] : '保存菜式' }}</el-button>
                </div>
                <!-- <el-button type="warning" size="mini" @click="ClearItems" :disabled="running || Items.length == 0">{{ lstLabel.length > 7 ? lstLabel[7] : '清空菜式' }}</el-button> -->
            </div>
            <div style="display: flex;" v-if="menu_code.trim().length > 0">
                <div style="flex-grow: 0; flex-shrink: 0; width: 120px;">{{ lstLabel.length > 22 ? lstLabel[22] : '餐牌編碼' }}:</div>
                <div style="flex-grow: 1;">
                    {{ menu_code }}
                </div>
            </div>
            <div style="clear: both; height: 25px;"></div>
            <el-table :data="Items" style="width: 100%;" border v-if="IsMobile() == null">
                <el-table-column prop="code" :label="lstLabel.length > 8 ? lstLabel[8] : '編碼'" />
                <el-table-column prop="name1" :label="lstLabel.length > 9 ? lstLabel[9] : '名稱'" />
                <el-table-column prop="name2" :label="lstLabel.length > 10 ? lstLabel[10] : '英文名稱'" />
                <el-table-column prop="name3" :label="lstLabel.length > 10 ? lstLabel[10] + '2': '英文名稱2'" />
                <el-table-column prop="price" :label="lstLabel.length > 11 ? lstLabel[11] : '價格'" />
                <el-table-column prop="type" :label="lstLabel.length > 12 ? lstLabel[12] : '種類'" />
            </el-table>
            <div v-else>
                <el-card v-for="(item, index) in Items" :key="index" style="margin-bottom: 10px;">
                    <div>{{lstLabel.length > 8 ? lstLabel[8] : '編碼'}}: {{ item.code }}</div>
                    <div>{{lstLabel.length > 9 ? lstLabel[9] : '名稱'}}: {{ item.name1 }}</div>
                    <div>{{lstLabel.length > 10 ? lstLabel[10] : '英文名稱'}}: {{ item.name2 }}</div>
                    <div>{{lstLabel.length > 10 ? lstLabel[10] + '2': '英文名稱2'}}: {{ item.name3 }}</div>
                    <div>{{lstLabel.length > 11 ? lstLabel[11] : '價格'}}: {{ item.price }}</div>
                    <div>{{lstLabel.length > 12 ? lstLabel[12] : '種類'}}: {{ item.type }}</div>
                </el-card>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import UploadFile from "@/components/form/uploadFile_direct.vue";
import { IsMobile } from "@/script/common";
import { GetScaner, SaveMenu } from "@/api/rms86/ai_identity";

export default {
    name: "ai_scan_pic",
    components: { UploadFile },
    data() {
        return {
            scan_id: '',
            start32_code: '',
            start32_shop: '',
            customerName: '',
            lstLabel:[],
            login: true,
            login_errMsg: '',

            Items: [],
            menu_name: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
            menu_code: '',

            controller: new AbortController(),
            isStreaming: false,
            running: false,
            processIndex: 1,
            ItemsOfImage: 0,
        };
    },
    methods: {
        ClearItems() {
            this.$confirm(this.lstLabel.length > 18 ? this.lstLabel[18] : "清除所有識別到的菜式, 是否繼續?", 
                this.lstLabel.length > 15 ? this.lstLabel[15] : "提示", 
                {
                    confirmButtonText: this.lstLabel.length > 16 ? this.lstLabel[16] : "確定",
                    cancelButtonText: this.lstLabel.length > 17 ? this.lstLabel[17] : "取消",
                    type: "warning",
                }).then(() => {
                this.Items = [];
            })
                .catch(() => {
                    //取消操作
                });
        },
        async Recognition() {
            const fileComponent = this.$refs.Scan_File;
            if (fileComponent && fileComponent.GetFileList.length > 0) {
                //禁用選擇圖片
                //禁用按鈕
                this.running = true;
                this.menu_code = '';

                this.$nextTick(() => {
                    this.startRecognition();
                });
            }
            else {
                this.$message.error(this.lstLabel.length > 14 ? this.lstLabel[14] : "請先上傳圖片");
            }
        },
        async startRecognition() {
            const jsonRegex = /\{(?:[^{}]|\\.)*\}/;
            const fileComponent = this.$refs.Scan_File;
            let apiUrl = window.location.protocol + '//' + window.location.host + '/api/FileUpload/GetAIResponse';
            if (window.location.port.length > 0 && window.location.port != '443' && window.location.port != '80') {
                //本地測試，不能用 devServer 轉發
                apiUrl = window.location.protocol + '//' + window.location.hostname + ":9998/FileUpload/GetAIResponse";
            }
            this.processIndex = 1;
            for (let f1 of fileComponent.GetFileList) {
                this.ItemsOfImage = 0;
                let response = await fetch(apiUrl, {
                    method: 'POST',
                    body: JSON.stringify({ url: f1.url, scan_id: this.scan_id }),
                    signal: this.controller.signal
                });
                if (!response.ok) {
                    throw new Error(`API请求失败: ${response.status}`);
                }
                // #region 处理流式响应
                let reader = response.body.getReader();
                let decoder = new TextDecoder();
                let buffer = '';
                let itemCache = '';
                let itemItem = '';

                this.isStreaming = true;
                while (this.isStreaming) {
                    const { done, value } = await reader.read();

                    if (done) {
                        break;
                    }

                    // 解码并处理数据
                    buffer += decoder.decode(value, { stream: true });
                    const lines = buffer.split('\n');
                    buffer = lines.pop() || '';

                    for (const line of lines) {
                        const trimmedLine = line.trim();
                        if (!trimmedLine) continue;

                        // 处理SSE格式
                        let data = trimmedLine;
                        if (data.startsWith('data: ')) {
                            data = data.slice(6);
                        }

                        if (data === '[DONE]') {
                            this.isStreaming = false;
                            break;
                        }

                        let jsonData = {};
                        try {
                            // 尝试解析为JSON对象
                            jsonData = JSON.parse(data);
                        }
                        catch (e) {
                            continue;
                        }
                        try {
                            if (jsonData.choices && jsonData.choices[0] && jsonData.choices[0].finish_reason) {
                                console.log(jsonData.choices[0].finish_reason);
                            }
                            // 检查是否是结束标识
                            if (jsonData.done) {
                                this.isStreaming = false;
                                break;
                            }

                            // 检查是否是有效的菜品信息
                            if (jsonData.choices && jsonData.choices[0] && jsonData.choices[0].delta.content) {
                                // 尝试解析内容中的JSON
                                itemCache += jsonData.choices[0].delta.content;
                                //正則表達式截取菜式，確定菜式結構不保護子Json
                                let match = itemCache.match(jsonRegex);
                                if (match) {
                                    itemItem = match[0];
                                    itemCache = itemCache.slice(match.index + match[0].length);

                                    let dishInfo = {};
                                    try {
                                        dishInfo = JSON.parse(itemItem);
                                    }
                                    catch { }
                                    if (dishInfo.name1 && dishInfo.price) {
                                        //檢查是否已存在
                                        let exists = false;
                                        for (let it of this.Items) {
                                            const sameName = it.name1.trim().length > 0 ? it.name1 == dishInfo.name1 : it.name2 == dishInfo.name2;
                                            const samePrice = it.price == dishInfo.price;
                                            if (sameName && samePrice) {
                                                exists = true;
                                                break;
                                            }
                                        }
                                        if (!exists) {
                                            dishInfo.furl = f1.url;
                                            dishInfo.fname = f1.name;
                                            let value = dishInfo.price;
                                            dishInfo.price = !Number.isNaN(value) ? value : null;
                                            this.Items.push(dishInfo);
                                            this.ItemsOfImage++;
                                        }
                                    }
                                }
                            }
                        } catch (e) {
                            console.log(e);
                        }
                    }
                }
                this.processIndex++;
                // #endregion
            }
            this.$message.success(this.lstLabel.length > 19 ? this.lstLabel[19] : "識別完成");
            this.running = false;
        },

        async SaveItem() {
            if (this.menu_name.trim().length == 0) {
                this.$message.error(this.lstLabel.length > 20 ? this.lstLabel[20] : "請輸入餐牌名");
                return;
            }
            if (this.Items.length == 0) {
                this.$message.error(this.lstLabel.length > 21 ? this.lstLabel[21] : "沒有可保存的菜式");
                return;
            }
            let postParam = {
                scan_id: this.scan_id,
                menu_name: this.menu_name,
                items: this.Items
            };
            let resp = await SaveMenu(postParam);
            if (resp.success == 1) {
                this.$message.success(resp.message);
                this.$refs.Scan_File.clearFiles();
                //this.Items = [];
                //this.menu_name = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
                this.menu_code = resp.data;
            }
            else {
                this.$message.error(resp.message);
            }   
        },
        //全選餐牌名，以便修改
        selectAll() {
            this.$nextTick(() => {
                if (this.$refs.mname) {
                    this.$refs.mname.select();
                }
            });
        },
    },
    async mounted() {
        this.scan_id = this.$route.query.id;
        let data = await GetScaner({ params: { id: this.scan_id } });
        if (data.success == 1) {
            this.start32_code = data.data.start32_code;
            this.start32_shop = data.data.start32_shop;
            this.customerName = data.data.customername;
            this.login = true;
            this.lstLabel = data.data.lstLabel;
        }
        else {
            this.login = false;
            this.login_errMsg = data.message;
            //this.$message.error(data.message);
        }
    },
};
</script>
<style lang="less" scoped></style>